const sv = {
  common: {
    wallet: "plånbok",
    playPage: "spela",
    minTop: "minsta belopp är $10",
    maxTop: "högsta belopp är $500",
    website: "hemsida",
    signOut: "logga ut",
    hidden: "dold",
    victory: "vinst",
    wentWrong: "något gick snett, omdirigerar",
    stakeLabel:  "insats",
    howDoes:  "hur funkar det?",
    continue: "Fortsätt",
    continueWithGoogle: "Fortsätt med Google",
    continueWithApple: "Fortsätt med Apple",
    termsOfService: "användarvillkor",
    privacyPolicy: "integritetspolicy",
    termsOfServiceFooter: "användarvillkor",
    privacyPolicyFooter: "integritetspolicy",
    verificationCode: "verifieringskod",
    verify: "verifiera",
    account: "konto",
    error: "ett fel inträffade\n",
    checkBackLater: "försök igen senare",
    looking: "söker...",
    yes: "ja",
    no: "nej",
    pleaseSelect: "Vänligen välj\n",
    disclaimer: "genom att fortsätta godkänner du våra\n",
    and: "och",
  },
  endOfGame: {
    wonByCheckmate: "vann på schackmatt",
    lostOnTime: "förlorade på tid",
    resigns: "gav upp",
    gameDrawnByAgreement: "remi genom överenskommelse",
    abandonedTheGame: "övergav partiet",
    gameAborted: "partiet avbrutet",
    gameDrawnByStalemate: "remi genom patt",
    gameDrawnByFiftyMoveRule: "remi genom 50-dragsregeln",
    gameDrawnByInsufficientMaterial: "remi genom otillräckligt material",
    gameDrawnByThreefoldRepetition: "remi genom dragupprepning",
    white: "vit",
    black: "svart",
    draw: "remi",
    victory: "vinst",
    defeat: "förlust",
    aborted: "avbrutet",
    inspectBoard: "visa brädet",
    returnToEndOfGameModal: "fortsätt",
  },
  byPhone:{
    continueOnPhone: "fortsätt på telefonen",
    or: "eller",
    continueOnWeb: "fortsätt på webben",
    disclaimer: "praktiskt om du har en bild på din ID-handling på datorn"
  },
  signUp: {
    email: "e-postadress",
    username: "användarnamn",
    usernameInvalid: "ogiltigt användarnamn",
    emailInvalid: "ogiltig e-postadress",
    login: "logga in",
    continueWithPhone: "Fortsätt med telefonnummer",
    tickBoxes: "bocka för\nnågra rutor",
    confirm: "Jag bekräftar att\n",
    resideIn: "Jag bor i\n",
    notPEP: "Jag är inte en person i politiskt utsatt ställning (PEP), en familjemedlem eller känd medarbetare till en PEP\n",
    purpose: "Syftet och arten av min relation med Gambit är uteslutande att använda tjänsten för underhållning\n",
    soleBenefit: "Jag kommer att använda tjänsten uteslutande för min egen skull och att det inte finns någon annan verklig ägare\n",
  },
  identity: {
    beingVerified: "identitet\nverifieras",
    verified: "verifierad\n",
    failed: "verifiering\nmisslyckades",
  },
  payment: {
    failed: "betalning misslyckades.\nvänligen försök igen",
    successful: "betalning\nlyckades!",
    toppedUp: "du har fyllt på saldo!\n",
    topUp: "fyll på\n",
    payWith: "betala med...\n",
  },
  gameplay: {
    play: "spela\n",
    challenge: "utmanar dig på",
    gameWorth: "spel värt\n",
    whatsYourNumber: "vad är ditt\nnummer?",
    receiveCode: "du kommer att få en verifieringskod\ninom kort",
    matchedOpponent: "Du kommer att matchas mot en motståndare med liknande rating.",
    stake: {
      total: "Totalt belopp som satsas visas nedan.",
      contribution: "Du bidrar med ungefär hälften av det beloppet.",
      weakerOpponent: "Om du matchas mot en svagare motståndare betalar du en större del av insatsen.",
      strongerOpponent: "Om du matchas mot en starkare motståndare betalar du en mindre del av insatsen.",
    },
    supportInfo: "Besök vår supportsida för mer information.\n",
    continueBrowser: "fortsätt i din webbläsare",
    continuePhone: "fortsätt i telefonen",
    getStarted: "kom igång",
    sentText: "vi har skickat ett\nsms till dig\n",
    enterReceivedCode: "ange den mottagna verifieringskoden",
    wrongCode: "fel kod, försök igen\n",
    secPerMove: "sek/drag",
    resign: {
      prompt: "är du säker på att du vill ge upp?",
    },
    draw: {
      offer: "acceptera remi?",
    },
    rating: "rating\n",
    balance: "saldo\n",
    rematch: "returmatch\n",
    newOpponent: "ny motståndare\n",
    home: "hem\n",
    rematchOffer: "Din motståndare erbjuder ett nytt parti. Acceptera?",
    leaveGame: "Du spelar för närvarande ett parti. Är du säker på att du vill lämna?",
    room: "rum:\n",
    gameTypes: {
      bullet: {
        title: "bullet\n",
        description: "Adrenalinfyllt schack. Du och din motståndare får bara 1 minut vardera att vinna spelet.",
      },
      blitz: {
        title: "blitz\n",
        description: "Du och din motståndare får 3 minuter vardera att vinna spelet.",
      },
    },
    stakes: {
      unlockNext: "spela {amount} fler spel för att låsa upp nästa insats",
      allUnlocked: "du har låst upp alla insatser",
    },
    withdraw: "ta ut pengar\n",
  },
  puzzle: {
    begin: "börja",
    next: "nästa",
    unavailableInYourRegion: "ej tillgängligt",
    puzzle: "pussel",
    whiteToPlay: "vit vid draget",
    blackToPlay: "svart vid draget",
    time: "tid",
    solution: "lösning",
    somethingWentWrong: "något gick fel",
    rating: "rating",
    credits: "krediter",
    puzzleFailed: "förlust",
    puzzleSolved: "vinst",
    correct: "rätt lösning",
    incorrect: "fel lösning",
    youRanOutOfTime: "du fick slut på tid",
    puzzleDescription: "Du har 10 sekunder + 2 sekunder/drag för att lösa ett pussel.",
    creditsLeft: "krediter kvar",
    refillIn: "påfyllning om",
    lastPuzzle: "Detta är ditt sista pussel, kom tillbaka senare för mer.",
    outOfCredits: "Du har slut på krediter, kom tillbaka senare.",
    locationPrompt: "Vi behöver din plats för att fortsätta. Om den är blockerad, vänligen aktivera den igen:",
    locationInstructions: "Klicka på ikonen i adressfältet, välj 'Tillåt alltid' och uppdatera sidan",
    creditsError: "Fel vid inläsning av krediter",
    moves: "Drag:",
  },
};

export {sv};